import { createStore } from './storeCreator';

const useCatalogStore = createStore<{
  open: boolean;
  toggleOpen: () => void;
  setOpen: (value: boolean) => void;
}>(
  set => ({
    open: false,
    toggleOpen: () => set(state => ({ open: !state.open })),
    setOpen: (value: boolean) => set({ open: value }),
  }),
  { name: 'catalog-storage' }
);

export default useCatalogStore;
